var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.clss,style:(_vm.style),on:{"click":_vm.handleChoice}},[(_vm.hasImage)?[_c('figure',[_c('img',{attrs:{"src":_vm.content.item.img,"alt":_vm.content.item.label}})])]:_vm._e(),_vm._v(" "+_vm._s(_vm.content.item.label)+" "),(_vm.hasDesc)?[_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.content.item.desc))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }